import React, { useState } from "react";
import { formatDateTime } from "../../../common-data/Converts";
import {
  CalenderIcon,
  ClockIcon,
  PersonIcon,
} from "../../../../images/icons/icons";

const FollowupDesktop = ({ allFollowups, addFollowup, leadStatus }) => {
  const [expandedRemarks, setExpandedRemarks] = useState({});

  const toggleRemarks = (id) => {
    setExpandedRemarks((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const getStatusBadgeClass = (status) => {
    const statusLower = status?.toLowerCase();
    if (statusLower === "pending") return "status-pending";
    if (statusLower === "reschedule") return "status-reschedule";
    if (statusLower === "closure expected") return "status-closure";
    if (statusLower === "completed") return "status-completed";
    return "status-default";
  };

  // const getPriorityLevel = (followUpNumber) => {
  //   const num = parseInt(followUpNumber);
  //   if (num === 1) return "priority-high";
  //   if (num === 2) return "priority-medium";
  //   return "priority-low";
  // };

  const truncateText = (text, maxLength = 120) => {
    if (!text) return "";
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  if (!allFollowups || allFollowups.length === 0) {
    return (
      <div className="followup-desktop-empty">
        <div className="empty-state-icon">📋</div>
        <div className="empty-state-title">No Follow-ups Yet</div>
        <div className="empty-state-desc">
          Create your first follow-up to start tracking this lead
        </div>
        <button className="followup-add-btn" onClick={addFollowup}>
          <CalenderIcon />
          Create First Follow-up
        </button>
      </div>
    );
  }

  return (
    <div className="followup-desktop-container">
      <div className="followup-desktop-header">
        <div className="followup-header-info">
          <span className="followup-header-icon">📞</span>
          <span className="followup-header-title">Follow-up History</span>
          <span className="followup-count-badge">
            {allFollowups?.length} follow-ups
          </span>
        </div>

        {leadStatus !== "closed" && leadStatus !== "converted" && (
          <button className="followup-add-btn" onClick={addFollowup}>
            <CalenderIcon color="#fff" />
            Schedule New Follow-up
          </button>
        )}
      </div>

      <div className="followup-desktop-grid">
        {allFollowups.map((followup) => (
          <div key={followup?.id} className="followup-card">
            <div className="followup-card-header">
              <div className="followup-priority-section">
                <span
                  className={`followup-number`}
                  // ${getPriorityLevel(
                  //   followup?.follow_up_number
                  // )}
                >
                  #{followup?.follow_up_number}
                </span>
                <span className="followup-priority-label">
                  {`Follow-up Stage ${followup?.follow_up_number}`}
                </span>
              </div>
              <span
                className={`followup-status-badge ${getStatusBadgeClass(
                  followup?.follow_up_status
                )}`}
              >
                {followup?.follow_up_status?.replace(/_/g, " ")}
              </span>
            </div>

            <div className="followup-card-body">
              <div className="followup-priority-info">
                <div className="followup-info-item priority">
                  <span className="followup-info-icon"><CalenderIcon/></span>
                  <div className="followup-info-content">
                    <span className="followup-info-label">Last Activity</span>
                    <span className="followup-info-value highlight">
                      {formatDateTime(followup?.date_added)}
                    </span>
                  </div>
                </div>

                <div className="followup-info-item priority">
                  <span className="followup-info-icon">⏰</span>
                  <div className="followup-info-content">
                    <span className="followup-info-label">Scheduled On</span>
                    <span className="followup-info-value highlight">
                      {formatDateTime(followup?.scheduled_on)}
                    </span>
                  </div>
                </div>
              </div>

              <div className="followup-agent-info">
                <PersonIcon />
                <span className="followup-agent-name">
                  added by - {followup?.added_by_name}
                </span>
              </div>

              {followup?.remarks && (
                <div className="followup-remarks-section">
                  <div className="followup-remarks-label">Remarks:</div>
                  <div className="followup-remarks-content">
                    {expandedRemarks[followup?.id]
                      ? followup.remarks
                      : truncateText(followup.remarks)}
                    {followup.remarks.length > 120 && (
                      <button
                        className="followup-remarks-toggle"
                        onClick={() => toggleRemarks(followup?.id)}
                      >
                        {expandedRemarks[followup?.id]
                          ? "...Show Less"
                          : "...Read More"}
                      </button>
                    )}
                  </div>
                </div>
              )}

              {followup?.next_follow_up_date && (
                <div className="followup-next-info">
                  <ClockIcon />
                  <span>
                    Next: {formatDateTime(followup.next_follow_up_date)}
                  </span>
                </div>
              )}

              {followup?.follow_up_status?.toLowerCase() === "pending" &&
                leadStatus !== "closed" &&
                leadStatus !== "converted" && (
                  <div className="followup-action-section">
                    <button
                      className="followup-pending-action-btn"
                      onClick={addFollowup}
                    >
                      <CalenderIcon color="#fff" />
                      Create New Follow-up
                    </button>
                  </div>
                )}

              {followup?.follow_up_status?.toLowerCase() === "pending" &&
                (leadStatus === "closed" || leadStatus === "converted") && (
                  <div className="followup-action-section">
                    <div className={`followup-pending-remarks ${leadStatus}`}>
                      <span className="followup-pending-icon">📝</span>
                      <span className="followup-pending-text">
                        Lead is{" "}
                        {leadStatus === "converted" ? "converted" : "closed"}
                      </span>
                    </div>
                  </div>
                )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FollowupDesktop;
